
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("d6Ahp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $6gGPb = parcelRequire("6gGPb");


var $jC4nA = parcelRequire("jC4nA");


var $lSQgn = parcelRequire("lSQgn");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $ljQiY = parcelRequire("ljQiY");


const $b1fbd1cdbf216579$var$CursorIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "b1Pb5",
    name: "CursorIcon",
    loader: async ()=>(await (parcelRequire("5cJDB"))).CursorIcon
});

const $b1fbd1cdbf216579$var$CursorPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "d5MrK",
    name: "CursorPresenceIcon",
    loader: async ()=>(await (parcelRequire("3Kj88"))).CursorPresenceIcon
});

const $b1fbd1cdbf216579$var$ExternalPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "5eua7",
    name: "ExternalPresenceIcon",
    loader: async ()=>(await (parcelRequire("cRqOx"))).ExternalPresenceIcon
});

const $b1fbd1cdbf216579$var$CanvaPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ggvDj",
    name: "CanvaPresenceIcon",
    loader: async ()=>(await (parcelRequire("axrZ5"))).CanvaPresenceIcon
}); /**
     * The Claude, ChatGPT and Figma brand icons only render for the rare
     * `agentIcon === 'claude'` / `'chatgpt'` / `'figma'` cases, so — like the Cursor icon —
     * they are code-split into their own chunks and loaded after paint rather than weighing
     * down every chunk that includes this module.
     */ 

const $b1fbd1cdbf216579$var$ClaudeIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dxvVm",
    name: "ClaudeIcon",
    loader: async ()=>(await (parcelRequire("azBJu"))).ClaudeIcon
}); /**
     * Presence tiles render inside LazyAnalyticsDialog (LAZY). LoadablePaint here
     * crashes the byline dialog: "ClaudePresenceIcon [PAINT] has a higher priority
     * of it's parent component LazyAnalyticsDialog[LAZY]". Match Figma/Lovable and
     * load after paint.
     */ 

const $b1fbd1cdbf216579$var$ClaudePresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GVMA6",
    name: "ClaudePresenceIcon",
    loader: async ()=>(await (parcelRequire("hUBX0"))).ClaudePresenceIcon
});

const $b1fbd1cdbf216579$var$ChatGptIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "EXw4a",
    name: "ChatGptIcon",
    loader: async ()=>(await (parcelRequire("e3UW8"))).ChatGptIcon
});

const $b1fbd1cdbf216579$var$FigmaPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "NcBW4",
    name: "FigmaPresenceIcon",
    loader: async ()=>(await (parcelRequire("iisvf"))).FigmaPresenceIcon
});

const $b1fbd1cdbf216579$var$LovablePresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "hiKXZ",
    name: "LovablePresenceIcon",
    loader: async ()=>(await (parcelRequire("c1en2"))).LovablePresenceIcon
});

const $b1fbd1cdbf216579$var$ReplitPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BdY0I",
    name: "ReplitPresenceIcon",
    loader: async ()=>(await (parcelRequire("acPvf"))).ReplitPresenceIcon
}); /**
     * The Dia and Codex icons only render for the rare `agentIcon === 'dia'` / `'codex'`
     * cases, so — like the other brand icons — they are code-split into their own chunks and
     * loaded after paint.
     */ 

const $b1fbd1cdbf216579$var$DiaIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "00DEF",
    name: "DiaIcon",
    loader: async ()=>(await (parcelRequire("4U3Dw"))).DiaIcon
});

const $b1fbd1cdbf216579$var$CodexIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "UYqXM",
    name: "CodexIcon",
    loader: async ()=>(await (parcelRequire("1IFox"))).CodexIcon
});

const $b1fbd1cdbf216579$var$CodexPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "stDdE",
    name: "CodexPresenceIcon",
    loader: async ()=>(await (parcelRequire("4EBC2"))).CodexPresenceIcon
});

const $b1fbd1cdbf216579$var$RovoPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "i0C6G",
    name: "RovoPresenceIcon",
    loader: async ()=>(await (parcelRequire("04yz9"))).RovoPresenceIcon
});

const $b1fbd1cdbf216579$var$GrokIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rHk7j",
    name: "GrokIcon",
    loader: async ()=>(await (parcelRequire("4bG1w"))).GrokIcon
});

const $b1fbd1cdbf216579$var$GitHubCopilotIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dP-Du",
    name: "GitHubCopilotIcon",
    loader: async ()=>(await (parcelRequire("SbELt"))).GitHubCopilotIcon
});

const $b1fbd1cdbf216579$var$VisualStudioCodeIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Nlex7",
    name: "VisualStudioCodeIcon",
    loader: async ()=>(await (parcelRequire("5yNuQ"))).VisualStudioCodeIcon
});

const $b1fbd1cdbf216579$var$OpenCodeIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IBz4P",
    name: "OpenCodeIcon",
    loader: async ()=>(await (parcelRequire("dPVqa"))).OpenCodeIcon
});

const $b1fbd1cdbf216579$var$HermesAgentIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ygIH0",
    name: "HermesAgentIcon",
    loader: async ()=>(await (parcelRequire("jXHfv"))).HermesAgentIcon
});

const $b1fbd1cdbf216579$var$KiroIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GmIrZ",
    name: "KiroIcon",
    loader: async ()=>(await (parcelRequire("lQMhC"))).KiroIcon
});

const $b1fbd1cdbf216579$var$FirstPartyAgentPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "RlN7s",
    name: "FirstPartyAgentPresenceIcon",
    loader: async ()=>(await (parcelRequire("5hHPF"))).FirstPartyAgentPresenceIcon
});

const $b1fbd1cdbf216579$var$AmplitudePresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "erxfS",
    name: "AmplitudePresenceIcon",
    loader: async ()=>(await (parcelRequire("detRP"))).AmplitudePresenceIcon
});

const $b1fbd1cdbf216579$var$ChatGptPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "5Sn5H",
    name: "ChatGptPresenceIcon",
    loader: async ()=>(await (parcelRequire("hUKow"))).ChatGptPresenceIcon
});

const $b1fbd1cdbf216579$var$CortexPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "aKhvU",
    name: "CortexPresenceIcon",
    loader: async ()=>(await (parcelRequire("ksUc9"))).CortexPresenceIcon
});

const $b1fbd1cdbf216579$var$DatabricksPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "56vYg",
    name: "DatabricksPresenceIcon",
    loader: async ()=>(await (parcelRequire("1ymsJ"))).DatabricksPresenceIcon
});

const $b1fbd1cdbf216579$var$GitHubCopilotPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zvpYp",
    name: "GitHubCopilotPresenceIcon",
    loader: async ()=>(await (parcelRequire("l02sw"))).GitHubCopilotPresenceIcon
});

const $b1fbd1cdbf216579$var$ManusPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "NPozu",
    name: "ManusPresenceIcon",
    loader: async ()=>(await (parcelRequire("dJURp"))).ManusPresenceIcon
});

const $b1fbd1cdbf216579$var$OpenAiPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "E8yL1",
    name: "OpenAiPresenceIcon",
    loader: async ()=>(await (parcelRequire("cn2Sm"))).OpenAiPresenceIcon
});

const $b1fbd1cdbf216579$var$SlackPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "shcwR",
    name: "SlackPresenceIcon",
    loader: async ()=>(await (parcelRequire("1Z3b3"))).SlackPresenceIcon
});

const $b1fbd1cdbf216579$var$AntigravityPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HAuKS",
    name: "AntigravityPresenceIcon",
    loader: async ()=>(await (parcelRequire("9AvHs"))).AntigravityPresenceIcon
});

const $b1fbd1cdbf216579$var$DiaPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "khAwZ",
    name: "DiaPresenceIcon",
    loader: async ()=>(await (parcelRequire("ledxA"))).DiaPresenceIcon
});

const $b1fbd1cdbf216579$var$GeminiPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "M9R0Y",
    name: "GeminiPresenceIcon",
    loader: async ()=>(await (parcelRequire("hPYjR"))).GeminiPresenceIcon
});

const $b1fbd1cdbf216579$var$GrokPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3EC9u",
    name: "GrokPresenceIcon",
    loader: async ()=>(await (parcelRequire("l4BGG"))).GrokPresenceIcon
});

const $b1fbd1cdbf216579$var$HermesAgentPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bHfrR",
    name: "HermesAgentPresenceIcon",
    loader: async ()=>(await (parcelRequire("2xQnO"))).HermesAgentPresenceIcon
});

const $b1fbd1cdbf216579$var$KiroPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g9WFV",
    name: "KiroPresenceIcon",
    loader: async ()=>(await (parcelRequire("jAGuJ"))).KiroPresenceIcon
});

const $b1fbd1cdbf216579$var$MicrosoftCopilotPresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fPa7_",
    name: "MicrosoftCopilotPresenceIcon",
    loader: async ()=>(await (parcelRequire("4PkVb"))).MicrosoftCopilotPresenceIcon
});

const $b1fbd1cdbf216579$var$VisualStudioCodePresenceIcon = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Q1mvx",
    name: "VisualStudioCodePresenceIcon",
    loader: async ()=>(await (parcelRequire("8xU4s"))).VisualStudioCodePresenceIcon
});
const $b1fbd1cdbf216579$var$unidentifiedAgentAvatarBackgroundStyles = null;
const $b1fbd1cdbf216579$var$AGENT_AVATAR_CLIP_PATH = 'polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)';
const $b1fbd1cdbf216579$var$styles = {
    xxsmall: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F _3YEZNOdnbC",
    compactInlineSpacing: "_0GTcwRFQfX _2xTnZxFQfX",
    small: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _0GTcwRFQfX _2xTnZxFQfX",
    medium: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _2xTnZxFQfX",
    iconWrapperSmallNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC",
    iconWrapperMediumNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC",
    unidentifiedAgentAvatarSmall: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _0GTcwRFQfX _2xTnZxFQfX _1uo2ZfTcEg",
    unidentifiedAgentAvatarMedium: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _2xTnZxFQfX _1uo2ZfTcEg",
    unidentifiedAgentAvatarSmallNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _3YEZNOdnbC _1uo2ZfTcEg",
    unidentifiedAgentAvatarMediumNoSpacing: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02Uofl _0jFU0VUofl _3YEZNOdnbC _1uo2ZfTcEg",
    brandAgentTile: "_1uo2ZfTcEg _0KLXruDMqu",
    presenceGlyphTile: "_4bt5LAYvD1 _2WAcuGYvD1 _3iDTPbQ4SZ",
    avatarOffsetInlineStart: "_1VJPcac8DQ"
};
const $b1fbd1cdbf216579$var$AgentAvatarContainer = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing, children: children } = t0;
    if (avatarSize === "xxsmall") {
        const t1 = hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
        let t2;
        if ($[0] !== t1) {
            t2 = (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.xxsmall, t1);
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] !== children || $[3] !== t2) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: t2
            }, children);
            $[2] = children;
            $[3] = t2;
            $[4] = t3;
        } else t3 = $[4];
        return t3;
    }
    if (avatarSize === "medium" && hasInlineSpacing) {
        let t1;
        if ($[5] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b1fbd1cdbf216579$var$styles.medium
            }, children);
            $[5] = children;
            $[6] = t1;
        } else t1 = $[6];
        return t1;
    }
    if (avatarSize === "medium") {
        let t1;
        if ($[7] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b1fbd1cdbf216579$var$styles.iconWrapperMediumNoSpacing
            }, children);
            $[7] = children;
            $[8] = t1;
        } else t1 = $[8];
        return t1;
    }
    if (hasInlineSpacing) {
        let t1;
        if ($[9] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b1fbd1cdbf216579$var$styles.small
            }, children);
            $[9] = children;
            $[10] = t1;
        } else t1 = $[10];
        return t1;
    }
    let t1;
    if ($[11] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b1fbd1cdbf216579$var$styles.iconWrapperSmallNoSpacing
        }, children);
        $[11] = children;
        $[12] = t1;
    } else t1 = $[12];
    return t1;
} : ({ avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing, children: children })=>{
    if (avatarSize === 'xxsmall') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.xxsmall, hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing)
    }, children);
    if (avatarSize === 'medium' && hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b1fbd1cdbf216579$var$styles.medium
    }, children);
    if (avatarSize === 'medium') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b1fbd1cdbf216579$var$styles.iconWrapperMediumNoSpacing
    }, children);
    if (hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b1fbd1cdbf216579$var$styles.small
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $b1fbd1cdbf216579$var$styles.iconWrapperSmallNoSpacing
    }, children);
};
const $b1fbd1cdbf216579$var$UnidentifiedAgentAvatar = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing } = t0;
    if (avatarSize === "xxsmall") {
        const t1 = hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
        let t2;
        if ($[0] !== t1) {
            t2 = (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.xxsmall, $b1fbd1cdbf216579$var$styles.brandAgentTile, t1);
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
                label: "",
                size: "small",
                color: "var(--ds-icon-subtle, #505258)"
            });
            $[2] = t3;
        } else t3 = $[2];
        let t4;
        if ($[3] !== t2) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: t2
            }, t3);
            $[3] = t2;
            $[4] = t4;
        } else t4 = $[4];
        return t4;
    }
    let t1;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2yBoao1qiM"
        ]);
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== avatarSize) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
            label: "",
            appearance: "gray",
            size: avatarSize
        });
        $[6] = avatarSize;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== t1 || $[9] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-testid": "unidentified-agent-avatar-background",
            className: t1
        }, t2);
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    const icon = t3;
    if (avatarSize === "medium" && hasInlineSpacing) {
        let t4;
        if ($[11] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarMedium
            }, icon);
            $[11] = icon;
            $[12] = t4;
        } else t4 = $[12];
        return t4;
    }
    if (avatarSize === "medium") {
        let t4;
        if ($[13] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarMediumNoSpacing
            }, icon);
            $[13] = icon;
            $[14] = t4;
        } else t4 = $[14];
        return t4;
    }
    if (hasInlineSpacing) {
        let t4;
        if ($[15] !== icon) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                testId: "unidentified-agent-avatar",
                xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarSmall
            }, icon);
            $[15] = icon;
            $[16] = t4;
        } else t4 = $[16];
        return t4;
    }
    let t4;
    if ($[17] !== icon) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "unidentified-agent-avatar",
            xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarSmallNoSpacing
        }, icon);
        $[17] = icon;
        $[18] = t4;
    } else t4 = $[18];
    return t4;
} : ({ avatarSize: avatarSize, hasInlineSpacing: hasInlineSpacing })=>{
    if (avatarSize === 'xxsmall') // IconTile starts at 20px; compose the compact 16px hexagon with the native small icon.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles.xxsmall, $b1fbd1cdbf216579$var$styles.brandAgentTile, hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
        label: "",
        size: "small",
        color: "var(--ds-icon-subtle, #505258)"
    }));
    const icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "unidentified-agent-avatar-background",
        className: (0, $hekY6.default)([
            "_2yBoao1qiM"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
        label: "",
        appearance: "gray",
        size: avatarSize
    }));
    if (avatarSize === 'medium' && hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarMedium
    }, icon);
    if (avatarSize === 'medium') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarMediumNoSpacing
    }, icon);
    if (hasInlineSpacing) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarSmall
    }, icon);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "unidentified-agent-avatar",
        xcss: $b1fbd1cdbf216579$var$styles.unidentifiedAgentAvatarSmallNoSpacing
    }, icon);
}; /**
    * Renders an agent row's leading icon: the fixed AiAgent/Rovo icon for agents that
    * couldn't be resolved to an account, otherwise the deterministic hexagon AgentAvatar
    * (or, when the resolved agent account has a `picture`, that avatar image inside the
    * hexagon).
    */ 
const $b1fbd1cdbf216579$export$951877a280bbd2e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(271);
    const { name: name, agentIcon: agentIcon, borderColor: t1, avatarUrl: avatarUrl, avatarSize: t2, markSize: markSize, isOffsetInlineStart: t3, hasInlineSpacing: t4, colorMode: t5 } = t0;
    const borderColor = t1 === undefined ? (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false) ? "var(--ds-surface, #FFFFFF)" : undefined : t1;
    const avatarSize = t2 === undefined ? "small" : t2;
    const isOffsetInlineStart = t3 === undefined ? false : t3;
    const hasInlineSpacing = t4 === undefined ? true : t4;
    const colorMode = t5 === undefined ? "light" : t5;
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            xxsmall: 16,
            small: 24,
            medium: 32
        };
        $[0] = t6;
    } else t6 = $[0];
    const iconSize = t6[avatarSize];
    const iconMarkSize = markSize ?? iconSize;
    let t7;
    if ($[1] !== avatarSize || $[2] !== hasInlineSpacing) {
        t7 = (icon)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                avatarSize: avatarSize,
                hasInlineSpacing: hasInlineSpacing
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b1fbd1cdbf216579$var$styles.presenceGlyphTile,
                testId: "presence-brand-tile"
            }, icon));
        $[1] = avatarSize;
        $[2] = hasInlineSpacing;
        $[3] = t7;
    } else t7 = $[3];
    const presenceTile = t7;
    let t8;
    bb0: {
        if (agentIcon === "ai-agent" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[4] !== borderColor || $[5] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ExternalPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[4] = borderColor;
                $[5] = iconSize;
                $[6] = t9;
            } else t9 = $[6];
            let t10;
            if ($[7] !== presenceTile || $[8] !== t9) {
                t10 = presenceTile(t9);
                $[7] = presenceTile;
                $[8] = t9;
                $[9] = t10;
            } else t10 = $[9];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "ai-agent") {
            let t9;
            if ($[10] !== avatarSize || $[11] !== hasInlineSpacing) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$UnidentifiedAgentAvatar, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                });
                $[10] = avatarSize;
                $[11] = hasInlineSpacing;
                $[12] = t9;
            } else t9 = $[12];
            t8 = t9;
            break bb0;
        }
        if (agentIcon === "rovo" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[13] !== borderColor || $[14] !== colorMode || $[15] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$RovoPresenceIcon, {
                    label: "",
                    size: iconSize,
                    colorMode: colorMode,
                    borderColor: borderColor
                });
                $[13] = borderColor;
                $[14] = colorMode;
                $[15] = iconSize;
                $[16] = t9;
            } else t9 = $[16];
            let t10;
            if ($[17] !== presenceTile || $[18] !== t9) {
                t10 = presenceTile(t9);
                $[17] = presenceTile;
                $[18] = t9;
                $[19] = t10;
            } else t10 = $[19];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "rovo") {
            let t9;
            if ($[20] !== iconMarkSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ljQiY.RovoIcon), {
                    label: "",
                    size: iconMarkSize
                });
                $[20] = iconMarkSize;
                $[21] = t9;
            } else t9 = $[21];
            let t10;
            if ($[22] !== avatarSize || $[23] !== hasInlineSpacing || $[24] !== t9) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                }, t9);
                $[22] = avatarSize;
                $[23] = hasInlineSpacing;
                $[24] = t9;
                $[25] = t10;
            } else t10 = $[25];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "cursor" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[26] !== borderColor || $[27] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CursorPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[26] = borderColor;
                $[27] = iconSize;
                $[28] = t9;
            } else t9 = $[28];
            let t10;
            if ($[29] !== presenceTile || $[30] !== t9) {
                t10 = presenceTile(t9);
                $[29] = presenceTile;
                $[30] = t9;
                $[31] = t10;
            } else t10 = $[31];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "cursor") {
            let t9;
            if ($[32] !== iconMarkSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CursorIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[32] = iconMarkSize;
                $[33] = t9;
            } else t9 = $[33];
            let t10;
            if ($[34] !== avatarSize || $[35] !== hasInlineSpacing || $[36] !== t9) {
                t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                    avatarSize: avatarSize,
                    hasInlineSpacing: hasInlineSpacing
                }, t9);
                $[34] = avatarSize;
                $[35] = hasInlineSpacing;
                $[36] = t9;
                $[37] = t10;
            } else t10 = $[37];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "canva" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[38] !== borderColor || $[39] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CanvaPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[38] = borderColor;
                $[39] = iconSize;
                $[40] = t9;
            } else t9 = $[40];
            let t10;
            if ($[41] !== presenceTile || $[42] !== t9) {
                t10 = presenceTile(t9);
                $[41] = presenceTile;
                $[42] = t9;
                $[43] = t10;
            } else t10 = $[43];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "claude" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[44] !== borderColor || $[45] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ClaudePresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[44] = borderColor;
                $[45] = iconSize;
                $[46] = t9;
            } else t9 = $[46];
            let t10;
            if ($[47] !== presenceTile || $[48] !== t9) {
                t10 = presenceTile(t9);
                $[47] = presenceTile;
                $[48] = t9;
                $[49] = t10;
            } else t10 = $[49];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "claude") {
            const t9 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t10 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t11;
            if ($[50] !== t10 || $[51] !== t9) {
                t11 = (0, $w6R6I.cx)(t9, t10);
                $[50] = t10;
                $[51] = t9;
                $[52] = t11;
            } else t11 = $[52];
            let t12;
            if ($[53] !== iconMarkSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ClaudeIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[53] = iconMarkSize;
                $[54] = t12;
            } else t12 = $[54];
            let t13;
            if ($[55] !== t11 || $[56] !== t12) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t11
                }, t12);
                $[55] = t11;
                $[56] = t12;
                $[57] = t13;
            } else t13 = $[57];
            t8 = t13;
            break bb0;
        }
        if (agentIcon === "chatgpt" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[58] !== borderColor || $[59] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ChatGptPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[58] = borderColor;
                $[59] = iconSize;
                $[60] = t9;
            } else t9 = $[60];
            let t10;
            if ($[61] !== presenceTile || $[62] !== t9) {
                t10 = presenceTile(t9);
                $[61] = presenceTile;
                $[62] = t9;
                $[63] = t10;
            } else t10 = $[63];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "antigravity" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[64] !== borderColor || $[65] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AntigravityPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[64] = borderColor;
                $[65] = iconSize;
                $[66] = t9;
            } else t9 = $[66];
            let t10;
            if ($[67] !== presenceTile || $[68] !== t9) {
                t10 = presenceTile(t9);
                $[67] = presenceTile;
                $[68] = t9;
                $[69] = t10;
            } else t10 = $[69];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "dia" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[70] !== borderColor || $[71] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DiaPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[70] = borderColor;
                $[71] = iconSize;
                $[72] = t9;
            } else t9 = $[72];
            let t10;
            if ($[73] !== presenceTile || $[74] !== t9) {
                t10 = presenceTile(t9);
                $[73] = presenceTile;
                $[74] = t9;
                $[75] = t10;
            } else t10 = $[75];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "gemini" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[76] !== borderColor || $[77] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GeminiPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[76] = borderColor;
                $[77] = iconSize;
                $[78] = t9;
            } else t9 = $[78];
            let t10;
            if ($[79] !== presenceTile || $[80] !== t9) {
                t10 = presenceTile(t9);
                $[79] = presenceTile;
                $[80] = t9;
                $[81] = t10;
            } else t10 = $[81];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "grok" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[82] !== borderColor || $[83] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GrokPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[82] = borderColor;
                $[83] = iconSize;
                $[84] = t9;
            } else t9 = $[84];
            let t10;
            if ($[85] !== presenceTile || $[86] !== t9) {
                t10 = presenceTile(t9);
                $[85] = presenceTile;
                $[86] = t9;
                $[87] = t10;
            } else t10 = $[87];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "hermes" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[88] !== borderColor || $[89] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$HermesAgentPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[88] = borderColor;
                $[89] = iconSize;
                $[90] = t9;
            } else t9 = $[90];
            let t10;
            if ($[91] !== presenceTile || $[92] !== t9) {
                t10 = presenceTile(t9);
                $[91] = presenceTile;
                $[92] = t9;
                $[93] = t10;
            } else t10 = $[93];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "kiro" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[94] !== borderColor || $[95] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$KiroPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[94] = borderColor;
                $[95] = iconSize;
                $[96] = t9;
            } else t9 = $[96];
            let t10;
            if ($[97] !== presenceTile || $[98] !== t9) {
                t10 = presenceTile(t9);
                $[97] = presenceTile;
                $[98] = t9;
                $[99] = t10;
            } else t10 = $[99];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "microsoft-copilot" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[100] !== borderColor || $[101] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$MicrosoftCopilotPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[100] = borderColor;
                $[101] = iconSize;
                $[102] = t9;
            } else t9 = $[102];
            let t10;
            if ($[103] !== presenceTile || $[104] !== t9) {
                t10 = presenceTile(t9);
                $[103] = presenceTile;
                $[104] = t9;
                $[105] = t10;
            } else t10 = $[105];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "vscode" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[106] !== borderColor || $[107] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$VisualStudioCodePresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[106] = borderColor;
                $[107] = iconSize;
                $[108] = t9;
            } else t9 = $[108];
            let t10;
            if ($[109] !== presenceTile || $[110] !== t9) {
                t10 = presenceTile(t9);
                $[109] = presenceTile;
                $[110] = t9;
                $[111] = t10;
            } else t10 = $[111];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "chatgpt") {
            const t9 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t10 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t11;
            if ($[112] !== t10 || $[113] !== t9) {
                t11 = (0, $w6R6I.cx)(t9, t10);
                $[112] = t10;
                $[113] = t9;
                $[114] = t11;
            } else t11 = $[114];
            let t12;
            if ($[115] !== iconMarkSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ChatGptIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[115] = iconMarkSize;
                $[116] = t12;
            } else t12 = $[116];
            let t13;
            if ($[117] !== t11 || $[118] !== t12) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t11
                }, t12);
                $[117] = t11;
                $[118] = t12;
                $[119] = t13;
            } else t13 = $[119];
            t8 = t13;
            break bb0;
        }
        if (agentIcon === "figma" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[120] !== borderColor || $[121] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$FigmaPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[120] = borderColor;
                $[121] = iconSize;
                $[122] = t9;
            } else t9 = $[122];
            let t10;
            if ($[123] !== presenceTile || $[124] !== t9) {
                t10 = presenceTile(t9);
                $[123] = presenceTile;
                $[124] = t9;
                $[125] = t10;
            } else t10 = $[125];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "lovable" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[126] !== borderColor || $[127] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$LovablePresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[126] = borderColor;
                $[127] = iconSize;
                $[128] = t9;
            } else t9 = $[128];
            let t10;
            if ($[129] !== presenceTile || $[130] !== t9) {
                t10 = presenceTile(t9);
                $[129] = presenceTile;
                $[130] = t9;
                $[131] = t10;
            } else t10 = $[131];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "replit" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[132] !== borderColor || $[133] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ReplitPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[132] = borderColor;
                $[133] = iconSize;
                $[134] = t9;
            } else t9 = $[134];
            let t10;
            if ($[135] !== presenceTile || $[136] !== t9) {
                t10 = presenceTile(t9);
                $[135] = presenceTile;
                $[136] = t9;
                $[137] = t10;
            } else t10 = $[137];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "dia") {
            const t9 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t10 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t11;
            if ($[138] !== t10 || $[139] !== t9) {
                t11 = (0, $w6R6I.cx)(t9, t10, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[138] = t10;
                $[139] = t9;
                $[140] = t11;
            } else t11 = $[140];
            let t12;
            if ($[141] !== iconMarkSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DiaIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[141] = iconMarkSize;
                $[142] = t12;
            } else t12 = $[142];
            let t13;
            if ($[143] !== t11 || $[144] !== t12) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t11
                }, t12);
                $[143] = t11;
                $[144] = t12;
                $[145] = t13;
            } else t13 = $[145];
            t8 = t13;
            break bb0;
        }
        if (agentIcon === "codex" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[146] !== borderColor || $[147] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CodexPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[146] = borderColor;
                $[147] = iconSize;
                $[148] = t9;
            } else t9 = $[148];
            let t10;
            if ($[149] !== presenceTile || $[150] !== t9) {
                t10 = presenceTile(t9);
                $[149] = presenceTile;
                $[150] = t9;
                $[151] = t10;
            } else t10 = $[151];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "first-party" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[152] !== borderColor || $[153] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$FirstPartyAgentPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[152] = borderColor;
                $[153] = iconSize;
                $[154] = t9;
            } else t9 = $[154];
            let t10;
            if ($[155] !== presenceTile || $[156] !== t9) {
                t10 = presenceTile(t9);
                $[155] = presenceTile;
                $[156] = t9;
                $[157] = t10;
            } else t10 = $[157];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "amplitude" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[158] !== borderColor || $[159] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AmplitudePresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[158] = borderColor;
                $[159] = iconSize;
                $[160] = t9;
            } else t9 = $[160];
            let t10;
            if ($[161] !== presenceTile || $[162] !== t9) {
                t10 = presenceTile(t9);
                $[161] = presenceTile;
                $[162] = t9;
                $[163] = t10;
            } else t10 = $[163];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "cortex" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[164] !== borderColor || $[165] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CortexPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[164] = borderColor;
                $[165] = iconSize;
                $[166] = t9;
            } else t9 = $[166];
            let t10;
            if ($[167] !== presenceTile || $[168] !== t9) {
                t10 = presenceTile(t9);
                $[167] = presenceTile;
                $[168] = t9;
                $[169] = t10;
            } else t10 = $[169];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "databricks" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[170] !== borderColor || $[171] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DatabricksPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[170] = borderColor;
                $[171] = iconSize;
                $[172] = t9;
            } else t9 = $[172];
            let t10;
            if ($[173] !== presenceTile || $[174] !== t9) {
                t10 = presenceTile(t9);
                $[173] = presenceTile;
                $[174] = t9;
                $[175] = t10;
            } else t10 = $[175];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "github-copilot" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[176] !== borderColor || $[177] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GitHubCopilotPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[176] = borderColor;
                $[177] = iconSize;
                $[178] = t9;
            } else t9 = $[178];
            let t10;
            if ($[179] !== presenceTile || $[180] !== t9) {
                t10 = presenceTile(t9);
                $[179] = presenceTile;
                $[180] = t9;
                $[181] = t10;
            } else t10 = $[181];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "manus" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[182] !== borderColor || $[183] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ManusPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[182] = borderColor;
                $[183] = iconSize;
                $[184] = t9;
            } else t9 = $[184];
            let t10;
            if ($[185] !== presenceTile || $[186] !== t9) {
                t10 = presenceTile(t9);
                $[185] = presenceTile;
                $[186] = t9;
                $[187] = t10;
            } else t10 = $[187];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "openai" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[188] !== borderColor || $[189] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$OpenAiPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[188] = borderColor;
                $[189] = iconSize;
                $[190] = t9;
            } else t9 = $[190];
            let t10;
            if ($[191] !== presenceTile || $[192] !== t9) {
                t10 = presenceTile(t9);
                $[191] = presenceTile;
                $[192] = t9;
                $[193] = t10;
            } else t10 = $[193];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "slack" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            let t9;
            if ($[194] !== borderColor || $[195] !== iconSize) {
                t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$SlackPresenceIcon, {
                    label: "",
                    size: iconSize,
                    borderColor: borderColor
                });
                $[194] = borderColor;
                $[195] = iconSize;
                $[196] = t9;
            } else t9 = $[196];
            let t10;
            if ($[197] !== presenceTile || $[198] !== t9) {
                t10 = presenceTile(t9);
                $[197] = presenceTile;
                $[198] = t9;
                $[199] = t10;
            } else t10 = $[199];
            t8 = t10;
            break bb0;
        }
        if (agentIcon === "codex") {
            const t9 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t10 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t11;
            if ($[200] !== t10 || $[201] !== t9) {
                t11 = (0, $w6R6I.cx)(t9, t10, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[200] = t10;
                $[201] = t9;
                $[202] = t11;
            } else t11 = $[202];
            let t12;
            if ($[203] !== iconMarkSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CodexIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[203] = iconMarkSize;
                $[204] = t12;
            } else t12 = $[204];
            let t13;
            if ($[205] !== t11 || $[206] !== t12) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t11
                }, t12);
                $[205] = t11;
                $[206] = t12;
                $[207] = t13;
            } else t13 = $[207];
            t8 = t13;
            break bb0;
        }
        if (agentIcon === "grok" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            const t9 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t10 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t11;
            if ($[208] !== t10 || $[209] !== t9) {
                t11 = (0, $w6R6I.cx)(t9, t10, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[208] = t10;
                $[209] = t9;
                $[210] = t11;
            } else t11 = $[210];
            let t12;
            if ($[211] !== iconMarkSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GrokIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[211] = iconMarkSize;
                $[212] = t12;
            } else t12 = $[212];
            let t13;
            if ($[213] !== t11 || $[214] !== t12) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t11
                }, t12);
                $[213] = t11;
                $[214] = t12;
                $[215] = t13;
            } else t13 = $[215];
            t8 = t13;
            break bb0;
        }
        if (agentIcon === "github-copilot" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            const t9 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t10 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t11;
            if ($[216] !== t10 || $[217] !== t9) {
                t11 = (0, $w6R6I.cx)(t9, t10, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[216] = t10;
                $[217] = t9;
                $[218] = t11;
            } else t11 = $[218];
            let t12;
            if ($[219] !== iconMarkSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GitHubCopilotIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[219] = iconMarkSize;
                $[220] = t12;
            } else t12 = $[220];
            let t13;
            if ($[221] !== t11 || $[222] !== t12) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t11
                }, t12);
                $[221] = t11;
                $[222] = t12;
                $[223] = t13;
            } else t13 = $[223];
            t8 = t13;
            break bb0;
        }
        if (agentIcon === "vscode" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            const t9 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t10 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t11;
            if ($[224] !== t10 || $[225] !== t9) {
                t11 = (0, $w6R6I.cx)(t9, t10, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[224] = t10;
                $[225] = t9;
                $[226] = t11;
            } else t11 = $[226];
            let t12;
            if ($[227] !== iconMarkSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$VisualStudioCodeIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[227] = iconMarkSize;
                $[228] = t12;
            } else t12 = $[228];
            let t13;
            if ($[229] !== t11 || $[230] !== t12) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t11
                }, t12);
                $[229] = t11;
                $[230] = t12;
                $[231] = t13;
            } else t13 = $[231];
            t8 = t13;
            break bb0;
        }
        if (agentIcon === "open-code" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            const t9 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t10 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t11;
            if ($[232] !== t10 || $[233] !== t9) {
                t11 = (0, $w6R6I.cx)(t9, t10, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[232] = t10;
                $[233] = t9;
                $[234] = t11;
            } else t11 = $[234];
            let t12;
            if ($[235] !== iconMarkSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$OpenCodeIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[235] = iconMarkSize;
                $[236] = t12;
            } else t12 = $[236];
            let t13;
            if ($[237] !== t11 || $[238] !== t12) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t11
                }, t12);
                $[237] = t11;
                $[238] = t12;
                $[239] = t13;
            } else t13 = $[239];
            t8 = t13;
            break bb0;
        }
        if (agentIcon === "hermes" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            const t9 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t10 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t11;
            if ($[240] !== t10 || $[241] !== t9) {
                t11 = (0, $w6R6I.cx)(t9, t10, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[240] = t10;
                $[241] = t9;
                $[242] = t11;
            } else t11 = $[242];
            let t12;
            if ($[243] !== iconMarkSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$HermesAgentIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[243] = iconMarkSize;
                $[244] = t12;
            } else t12 = $[244];
            let t13;
            if ($[245] !== t11 || $[246] !== t12) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t11
                }, t12);
                $[245] = t11;
                $[246] = t12;
                $[247] = t13;
            } else t13 = $[247];
            t8 = t13;
            break bb0;
        }
        if (agentIcon === "kiro" && (0, $6mKj3.expVal)("dual_agent_avatar_card", "isEnabled", false)) {
            const t9 = $b1fbd1cdbf216579$var$styles[avatarSize];
            const t10 = avatarSize === "xxsmall" && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing;
            let t11;
            if ($[248] !== t10 || $[249] !== t9) {
                t11 = (0, $w6R6I.cx)(t9, t10, $b1fbd1cdbf216579$var$styles.brandAgentTile);
                $[248] = t10;
                $[249] = t9;
                $[250] = t11;
            } else t11 = $[250];
            let t12;
            if ($[251] !== iconMarkSize) {
                t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$KiroIcon, {
                    label: "",
                    size: iconMarkSize
                });
                $[251] = iconMarkSize;
                $[252] = t12;
            } else t12 = $[252];
            let t13;
            if ($[253] !== t11 || $[254] !== t12) {
                t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    xcss: t11
                }, t12);
                $[253] = t11;
                $[254] = t12;
                $[255] = t13;
            } else t13 = $[255];
            t8 = t13;
            break bb0;
        }
        const t9 = borderColor === undefined;
        let t10;
        if ($[256] !== avatarSize || $[257] !== avatarUrl || $[258] !== name || $[259] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
                size: avatarSize,
                name: name,
                label: "",
                imageUrl: avatarUrl,
                showBorder: t9
            });
            $[256] = avatarSize;
            $[257] = avatarUrl;
            $[258] = name;
            $[259] = t9;
            $[260] = t10;
        } else t10 = $[260];
        const accountAvatar = t10;
        let t11;
        if ($[261] !== accountAvatar || $[262] !== borderColor) {
            t11 = borderColor === undefined ? accountAvatar : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $b1fbd1cdbf216579$var$styles.brandAgentTile,
                style: {
                    backgroundColor: borderColor
                }
            }, accountAvatar);
            $[261] = accountAvatar;
            $[262] = borderColor;
            $[263] = t11;
        } else t11 = $[263];
        let t12;
        if ($[264] !== avatarSize || $[265] !== hasInlineSpacing || $[266] !== t11) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
                avatarSize: avatarSize,
                hasInlineSpacing: hasInlineSpacing
            }, t11);
            $[264] = avatarSize;
            $[265] = hasInlineSpacing;
            $[266] = t11;
            $[267] = t12;
        } else t12 = $[267];
        t8 = t12;
    }
    const avatar = t8;
    let t9;
    if ($[268] !== avatar || $[269] !== isOffsetInlineStart) {
        t9 = isOffsetInlineStart ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "agent-avatar-offset",
            xcss: $b1fbd1cdbf216579$var$styles.avatarOffsetInlineStart
        }, avatar) : avatar;
        $[268] = avatar;
        $[269] = isOffsetInlineStart;
        $[270] = t9;
    } else t9 = $[270];
    return t9;
} : ({ name: name, agentIcon: agentIcon, borderColor: borderColor = (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false) ? "var(--ds-surface, #FFFFFF)" : undefined, avatarUrl: avatarUrl, avatarSize: avatarSize = 'small', markSize: markSize, isOffsetInlineStart: isOffsetInlineStart = false, hasInlineSpacing: hasInlineSpacing = true, colorMode: colorMode = 'light' })=>{
    const iconSize = {
        xxsmall: 16,
        small: 24,
        medium: 32
    }[avatarSize];
    const iconMarkSize = markSize ?? iconSize;
    const presenceTile = (icon)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b1fbd1cdbf216579$var$styles.presenceGlyphTile,
            testId: "presence-brand-tile"
        }, icon));
    const avatar = (()=>{
        if (agentIcon === 'ai-agent' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ExternalPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'ai-agent') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$UnidentifiedAgentAvatar, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        });
        if (agentIcon === 'rovo' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$RovoPresenceIcon, {
            label: "",
            size: iconSize,
            colorMode: colorMode,
            borderColor: borderColor
        }));
        if (agentIcon === 'rovo') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ljQiY.RovoIcon), {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'cursor' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CursorPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'cursor') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CursorIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'canva' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CanvaPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'claude' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ClaudePresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'claude') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ClaudeIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'chatgpt' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ChatGptPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'antigravity' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AntigravityPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'dia' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DiaPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'gemini' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GeminiPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'grok' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GrokPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'hermes' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$HermesAgentPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'kiro' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$KiroPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'microsoft-copilot' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$MicrosoftCopilotPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'vscode' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$VisualStudioCodePresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'chatgpt') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ChatGptIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'figma' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$FigmaPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'lovable' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$LovablePresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'replit' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ReplitPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'dia') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DiaIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'codex' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CodexPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'first-party' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$FirstPartyAgentPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'amplitude' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AmplitudePresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'cortex' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CortexPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'databricks' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$DatabricksPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'github-copilot' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GitHubCopilotPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'manus' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$ManusPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'openai' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$OpenAiPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'slack' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return presenceTile(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$SlackPresenceIcon, {
            label: "",
            size: iconSize,
            borderColor: borderColor
        }));
        if (agentIcon === 'codex') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$CodexIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'grok' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GrokIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'github-copilot' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$GitHubCopilotIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'vscode' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$VisualStudioCodeIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'open-code' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$OpenCodeIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'hermes' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$HermesAgentIcon, {
            label: "",
            size: iconMarkSize
        }));
        if (agentIcon === 'kiro' && (0, $6mKj3.expVal)('dual_agent_avatar_card', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($b1fbd1cdbf216579$var$styles[avatarSize], avatarSize === 'xxsmall' && hasInlineSpacing && $b1fbd1cdbf216579$var$styles.compactInlineSpacing, $b1fbd1cdbf216579$var$styles.brandAgentTile)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$KiroIcon, {
            label: "",
            size: iconMarkSize
        }));
        const accountAvatar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
            size: avatarSize,
            name: name,
            label: "",
            imageUrl: avatarUrl,
            showBorder: borderColor === undefined
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b1fbd1cdbf216579$var$AgentAvatarContainer, {
            avatarSize: avatarSize,
            hasInlineSpacing: hasInlineSpacing
        }, borderColor === undefined ? accountAvatar : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $b1fbd1cdbf216579$var$styles.brandAgentTile,
            style: {
                backgroundColor: borderColor
            }
        }, accountAvatar));
    })();
    return isOffsetInlineStart ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "agent-avatar-offset",
        xcss: $b1fbd1cdbf216579$var$styles.avatarOffsetInlineStart
    }, avatar) : avatar;
};
module.exports["AgentRowAvatar"] = $b1fbd1cdbf216579$export$951877a280bbd2e;

});

parcelRegister("ljQiY", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $d64e44b6455460db$export$e23ae35269442b4f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { label: t1, size: t2 } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? 16 : t2;
    const clipId = (0, $cozmU.useId)();
    const t3 = label ? "img" : "presentation";
    const t4 = label || undefined;
    const t5 = label ? undefined : true;
    const t6 = `url(#${clipId})`;
    let t10;
    let t7;
    let t8;
    let t9;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.0615 20.8951L5.47045 26.4325L3.56007 25.3303C2.43818 24.6835 1.7439 23.4836 1.7439 22.1908V9.82129C1.7439 8.52343 2.4341 7.32872 3.55933 6.68226L11.6173 2.0332C11.5995 2.08338 11.5824 2.13389 11.5662 2.18472C11.4171 2.6476 11.338 3.13666 11.338 3.63654V16.0061C11.338 17.7052 12.2431 19.2725 13.7181 20.1203L15.0615 20.8951Z",
            fill: "#1868DB"
        });
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.0615 20.8945L5.47046 26.4319L14.2797 31.5144C15.3815 32.1496 16.7374 32.1609 17.8482 31.5482C17.8683 31.5326 17.8898 31.5182 17.9124 31.5051C18.704 31.0488 19.2828 30.317 19.555 29.4716C19.6657 29.1222 19.7243 28.7529 19.7243 28.3749V23.5835L15.0615 20.8945Z",
            fill: "#6A9A23"
        });
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28.6364 6.66986L26.5817 5.48438L16.9906 11.0218L18.479 11.8801C19.9542 12.7278 20.8587 14.2949 20.8587 15.9942V28.3637C20.8587 28.8643 20.7794 29.354 20.6298 29.8174C20.6138 29.8676 20.597 29.9175 20.5793 29.967L28.6373 25.318C29.7626 24.6715 30.4528 23.4768 30.4528 22.1789V9.80941C30.4528 8.51667 29.7583 7.31666 28.6364 6.66986Z",
            fill: "#AF59E1"
        });
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.9875 11.0216L12.4691 8.41593V3.62449C12.4691 3.24694 12.5275 2.87812 12.6381 2.52898C12.9098 1.68399 13.4877 0.95247 14.2784 0.495822L14.2808 0.494438C14.3035 0.481361 14.3251 0.466857 14.3452 0.451262C15.456 -0.161474 16.8119 -0.150218 17.9137 0.485033L26.5786 5.48421L16.9875 11.0216Z",
            fill: "#FCA700"
        });
        $[0] = t10;
        $[1] = t7;
        $[2] = t8;
        $[3] = t9;
    } else {
        t10 = $[0];
        t7 = $[1];
        t8 = $[2];
        t9 = $[3];
    }
    let t11;
    if ($[4] !== t6) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: t6
        }, t7, t8, t9, t10);
        $[4] = t6;
        $[5] = t11;
    } else t11 = $[5];
    let t12;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "32",
            height: "32",
            fill: "white"
        });
        $[6] = t12;
    } else t12 = $[6];
    let t13;
    if ($[7] !== clipId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: clipId
        }, t12));
        $[7] = clipId;
        $[8] = t13;
    } else t13 = $[8];
    let t14;
    if ($[9] !== size || $[10] !== t11 || $[11] !== t13 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: size,
            height: size,
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: t3,
            "aria-label": t4,
            "aria-hidden": t5
        }, t11, t13);
        $[9] = size;
        $[10] = t11;
        $[11] = t13;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
        $[15] = t14;
    } else t14 = $[15];
    return t14;
} : ({ label: label = '', size: size = 16 })=>{
    const clipId = (0, $cozmU.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        "aria-hidden": label ? undefined : true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: `url(#${clipId})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0615 20.8951L5.47045 26.4325L3.56007 25.3303C2.43818 24.6835 1.7439 23.4836 1.7439 22.1908V9.82129C1.7439 8.52343 2.4341 7.32872 3.55933 6.68226L11.6173 2.0332C11.5995 2.08338 11.5824 2.13389 11.5662 2.18472C11.4171 2.6476 11.338 3.13666 11.338 3.63654V16.0061C11.338 17.7052 12.2431 19.2725 13.7181 20.1203L15.0615 20.8951Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.0615 20.8945L5.47046 26.4319L14.2797 31.5144C15.3815 32.1496 16.7374 32.1609 17.8482 31.5482C17.8683 31.5326 17.8898 31.5182 17.9124 31.5051C18.704 31.0488 19.2828 30.317 19.555 29.4716C19.6657 29.1222 19.7243 28.7529 19.7243 28.3749V23.5835L15.0615 20.8945Z",
        fill: "#6A9A23"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28.6364 6.66986L26.5817 5.48438L16.9906 11.0218L18.479 11.8801C19.9542 12.7278 20.8587 14.2949 20.8587 15.9942V28.3637C20.8587 28.8643 20.7794 29.354 20.6298 29.8174C20.6138 29.8676 20.597 29.9175 20.5793 29.967L28.6373 25.318C29.7626 24.6715 30.4528 23.4768 30.4528 22.1789V9.80941C30.4528 8.51667 29.7583 7.31666 28.6364 6.66986Z",
        fill: "#AF59E1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.9875 11.0216L12.4691 8.41593V3.62449C12.4691 3.24694 12.5275 2.87812 12.6381 2.52898C12.9098 1.68399 13.4877 0.95247 14.2784 0.495822L14.2808 0.494438C14.3035 0.481361 14.3251 0.466857 14.3452 0.451262C15.456 -0.161474 16.8119 -0.150218 17.9137 0.485033L26.5786 5.48421L16.9875 11.0216Z",
        fill: "#FCA700"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: clipId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white"
    }))));
};
module.exports["RovoIcon"] = $d64e44b6455460db$export$e23ae35269442b4f;

});

parcelRegister("5cJDB", function(module, exports) {

let $3ca17975e4f3b4f7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3ca17975e4f3b4f7$var$load("6ZG8u").then(()=>parcelRequire('6jEu7'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("3Kj88", function(module, exports) {

let $2ba481da298028fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2ba481da298028fa$var$load("d078q").then(()=>parcelRequire('hzh0G'));

});

parcelRegister("cRqOx", function(module, exports) {

let $95cf3c01f6a3fbd0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $95cf3c01f6a3fbd0$var$load("jeBZv").then(()=>parcelRequire('kZomH'));

});

parcelRegister("axrZ5", function(module, exports) {

let $7ac2b187060f556b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7ac2b187060f556b$var$load("k6lE4").then(()=>parcelRequire('iSJUf'));

});

parcelRegister("azBJu", function(module, exports) {

let $7b2a71372d458066$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7b2a71372d458066$var$load("5glfK").then(()=>parcelRequire('dk4rY'));

});

parcelRegister("hUBX0", function(module, exports) {

let $d0a51adcc339fcf0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0a51adcc339fcf0$var$load("dXdKj").then(()=>parcelRequire('12keR'));

});

parcelRegister("e3UW8", function(module, exports) {

let $a3cd82eeffec6166$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3cd82eeffec6166$var$load("kFqB1").then(()=>parcelRequire('eKYtd'));

});

parcelRegister("iisvf", function(module, exports) {

let $d5200486ac9db51b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5200486ac9db51b$var$load("62AY2").then(()=>parcelRequire('1jkOH'));

});

parcelRegister("c1en2", function(module, exports) {

let $8c00b9b89a2742dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8c00b9b89a2742dd$var$load("1NSgm").then(()=>parcelRequire('1TBoE'));

});

parcelRegister("acPvf", function(module, exports) {

let $76e2f9cb783aa055$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76e2f9cb783aa055$var$load("4Rnmf").then(()=>parcelRequire('8k6NU'));

});

parcelRegister("4U3Dw", function(module, exports) {

let $391f367cdb325622$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $391f367cdb325622$var$load("biaNf").then(()=>parcelRequire('13BtP'));

});

parcelRegister("1IFox", function(module, exports) {

let $140a02a6f70aa171$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $140a02a6f70aa171$var$load("33mZN").then(()=>parcelRequire('lrXp3'));

});

parcelRegister("4EBC2", function(module, exports) {

let $363812ea8042220c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $363812ea8042220c$var$load("3kcD5").then(()=>parcelRequire('dFAIb'));

});

parcelRegister("04yz9", function(module, exports) {

let $00db2fee4a0dfb1e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $00db2fee4a0dfb1e$var$load("4um3K").then(()=>parcelRequire('hswbu'));

});

parcelRegister("4bG1w", function(module, exports) {

let $30c8c97bb4b9fd9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $30c8c97bb4b9fd9a$var$load("iywqf").then(()=>parcelRequire('8Iy5T'));

});

parcelRegister("SbELt", function(module, exports) {

let $0a2e15ff56984941$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a2e15ff56984941$var$load("c9sWd").then(()=>parcelRequire('fS7L5'));

});

parcelRegister("5yNuQ", function(module, exports) {

let $40c685b0a5c7de7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $40c685b0a5c7de7a$var$load("fdu0f").then(()=>parcelRequire('cKQ8f'));

});

parcelRegister("dPVqa", function(module, exports) {

let $a12c946acc0ba5bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a12c946acc0ba5bf$var$load("8u4IE").then(()=>parcelRequire('jYUVi'));

});

parcelRegister("jXHfv", function(module, exports) {

let $e885135e1efd934d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e885135e1efd934d$var$load("dJDoX").then(()=>parcelRequire('bdcWi'));

});

parcelRegister("lQMhC", function(module, exports) {

let $fe83e8532d755559$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe83e8532d755559$var$load("fsgfk").then(()=>parcelRequire('dv9m9'));

});

parcelRegister("5hHPF", function(module, exports) {

let $3d908a7d29adcec1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d908a7d29adcec1$var$load("60Dx4").then(()=>parcelRequire('40zAY'));

});

parcelRegister("detRP", function(module, exports) {

let $9a23c02cee70c20c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9a23c02cee70c20c$var$load("gkTi7").then(()=>parcelRequire('bJnCe'));

});

parcelRegister("hUKow", function(module, exports) {

let $d0aba79d0f4e79e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0aba79d0f4e79e9$var$load("bB8Gp").then(()=>parcelRequire('axB4X'));

});

parcelRegister("ksUc9", function(module, exports) {

let $ee620356b3790458$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee620356b3790458$var$load("gByWd").then(()=>parcelRequire('gzCxZ'));

});

parcelRegister("1ymsJ", function(module, exports) {

let $121a63f77b935e4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $121a63f77b935e4e$var$load("4yDcQ").then(()=>parcelRequire('j89Z8'));

});

parcelRegister("l02sw", function(module, exports) {

let $f49b815a8f99f793$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f49b815a8f99f793$var$load("cAM1Y").then(()=>parcelRequire('kHAEb'));

});

parcelRegister("dJURp", function(module, exports) {

let $a00b959bf58bcbd0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a00b959bf58bcbd0$var$load("lTnC6").then(()=>parcelRequire('ag5rE'));

});

parcelRegister("cn2Sm", function(module, exports) {

let $9019dd12167c670d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9019dd12167c670d$var$load("dxw4H").then(()=>parcelRequire('gPmXi'));

});

parcelRegister("1Z3b3", function(module, exports) {

let $171df3dfdb344bc1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $171df3dfdb344bc1$var$load("8reyc").then(()=>parcelRequire('cXUwc'));

});

parcelRegister("9AvHs", function(module, exports) {

let $6fb010c81690ae08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6fb010c81690ae08$var$load("bJw8x").then(()=>parcelRequire('fn6zv'));

});

parcelRegister("ledxA", function(module, exports) {

let $f74568ac19ffb44c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f74568ac19ffb44c$var$load("7uGZG").then(()=>parcelRequire('h3Ihr'));

});

parcelRegister("hPYjR", function(module, exports) {

let $cfc5fd3e7b76411d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cfc5fd3e7b76411d$var$load("dQibE").then(()=>parcelRequire('cy9Hj'));

});

parcelRegister("l4BGG", function(module, exports) {

let $f57734a6cea414ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f57734a6cea414ae$var$load("f8Wnw").then(()=>parcelRequire('cqucg'));

});

parcelRegister("2xQnO", function(module, exports) {

let $1da74c00ddcf2822$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1da74c00ddcf2822$var$load("knn8O").then(()=>parcelRequire('elp5y'));

});

parcelRegister("jAGuJ", function(module, exports) {

let $e43257ada3c8dbb3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e43257ada3c8dbb3$var$load("hLnGd").then(()=>parcelRequire('jgCik'));

});

parcelRegister("4PkVb", function(module, exports) {

let $383c27636001b7f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $383c27636001b7f1$var$load("9MeFV").then(()=>parcelRequire('gAVq7'));

});

parcelRegister("8xU4s", function(module, exports) {

let $638ce650167e76be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $638ce650167e76be$var$load("5pNPC").then(()=>parcelRequire('7oMQm'));

});


//# sourceMappingURL=CommentsPanelWrapper.8a2b2c67.js.map
